import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GetFilterService {
  subject: Subject<any> = new Subject();
  private filtriApplicati: any;
  private filterColumn: any;
  constructor() { }

  getFilter(): string {
    return this.filtriApplicati;
  }

  setFilter(filter: string) {
    this.filtriApplicati = filter;
  }

  setFilterColumn(filter) {
    this.subject.next(filter)
  }
}
